module.exports = __webpack_public_path__ + "static/img/Venus.e836403.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/planet/Venus.svg
// module id = 1419
// module chunks = 0